import api                                  from '../../services/api'
import { useState, useEffect, useCallback } from 'react';
import { useFarol }                         from '../../contexts/FarolPageContext';
import EmptyResultSection                   from "./emptyResultSection";
import FarolCardsContainer                  from '../Cards/FarolCardsContainer'; 

const FarolCardsSection = () => {

    const { updateFarolCards, selectedPublicationId, cardsLayout } = useFarol()

    const isStacked = cardsLayout === 'empilhado'
    
    const [ _scenarioData, _setScenarioData ] = useState([])
    
    const _fetchFarolData = useCallback(async () => {
        
        if (!selectedPublicationId) return
        
        try {
            
            const response = await api.get(`/getFarolTerminals/${selectedPublicationId}`);
            const { farolTerminals } = response.data;
            _setScenarioData(farolTerminals)

        } catch (error) {
            console.error('Error fetching farols:', error);
        }
    
    }, [selectedPublicationId]);

    useEffect(() => {

        _fetchFarolData();

    }, [ updateFarolCards, _fetchFarolData, selectedPublicationId ]);
    
    return (
        
        <section className={isStacked ? 'flex flex-col gap-[15px]' : 'flex gap-[15px] flex-wrap'} >
            
            {_scenarioData.length > 0 ? (
                <>
                     {_scenarioData.map((farolTerminal) => (
                                        
                        <FarolCardsContainer       
    
                            key={farolTerminal.id} 
                            
                            faroTerminalId={farolTerminal.id} 
                            terminalName={farolTerminal.ownerTerminal.name}
                            isShipDockered={farolTerminal.isShipDockered} 
                            description={farolTerminal.description}
                            shipDescription={farolTerminal.shipDescription}
                            farols={farolTerminal.farolTerminalFarols}
                            isStacked={isStacked}

                        />))
                    }
                </>
                ) : (

                    <EmptyResultSection />
                
                )
            }
        </section>
    )

}

export default FarolCardsSection;